import React from "react";
import {
  useAssetCategories,
  useAssetCategoriesForm,
} from "../../../hooks/assets/useAssetCategories";
import {
  useAssetDisposalActionForm,
  useAssetDisposals,
  useAssetDisposalsForm,
} from "../../../hooks/assets/useAssetDisposals";
import { useAssets, useAssetsForm } from "../../../hooks/assets/useAssets";
import {
  useAssetStatusUpdates,
  useAssetStatusUpdatesForm,
} from "../../../hooks/assets/useAssetStatusUpdates";
import {
  useAssetStockCountActionForm,
  useAssetStockCounts,
  useAssetStockCountsForm,
} from "../../../hooks/assets/useAssetStockCounts";
import {
  useAssetTransferActionForm,
  useAssetTransfers,
  useAssetTransfersForm,
} from "../../../hooks/assets/useAssetTransfers";
import {
  API_ASSET_CATEGORIES,
  API_ASSET_DISPOSALS,
  API_ASSET_STATUS_UPDATES,
  API_ASSET_STOCK_COUNTS,
  API_ASSET_TRANSFERS,
  API_ASSETS,
} from "../../../utils/apis";
import { URL_ASSETS_DASHBOARD } from "../../../utils/urls";

const AssetDashboard = React.lazy(() => import("./AssetDashboard"));

export const assetRegisterRoutes = {
  asset_categories: useAssetCategories,
  assets: useAssets,
  asset_transfers: useAssetTransfers,
  asset_status_updates: useAssetStatusUpdates,
  asset_stock_counts: useAssetStockCounts,
  asset_disposals: useAssetDisposals,
};

export const assetFormRoutes = {
  asset_categories: useAssetCategoriesForm,
  assets: useAssetsForm,
  asset_transfers: useAssetTransfersForm,
  asset_status_updates: useAssetStatusUpdatesForm,
  asset_stock_counts: useAssetStockCountsForm,
  asset_disposals: useAssetDisposalsForm,
};

export const assetActionRoutes = {
  asset_transfers: useAssetTransferActionForm,
  asset_stock_counts: useAssetStockCountActionForm,
  asset_disposals: useAssetDisposalActionForm,
};

export const assetApis = {
  asset_categories: API_ASSET_CATEGORIES,
  assets: API_ASSETS,
  asset_transfers: API_ASSET_TRANSFERS,
  asset_status_updates: API_ASSET_STATUS_UPDATES,
  asset_stock_counts: API_ASSET_STOCK_COUNTS,
  asset_disposals: API_ASSET_DISPOSALS,
};

export const assetPageRoutes = [
  {
    path: URL_ASSETS_DASHBOARD,
    component: <AssetDashboard />,
    exact: true,
  },
];
